import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamond = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M56.5701 30.7415C57.1895 31.4835 57.1252 32.5744 56.47 33.2858C51.6705 38.497 42.7362 39.0117 39.7613 46.114C28.7443 70.153 29.9537 47.9617 19.2159 40.4821C16.4358 37.7613 2.21637 34.1631 8.65715 29.4012C8.72035 29.3547 8.78988 29.3103 8.85836 29.2712C11.788 27.5884 14.6744 25.8062 17.7115 24.3486C17.8548 24.2799 18.0086 24.2355 18.1635 24.2006C24.9909 22.6615 28.856 1.0082 34.7005 8.61462C38.4192 14.0414 40.0615 21.7049 46.516 24.3972C46.616 24.4384 46.7119 24.4902 46.8014 24.5505C50.0461 26.7417 54.0608 27.7364 56.5701 30.7415Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgDiamond);
export default ForwardRef;
